module.exports = __webpack_public_path__ + "static/gradient-5d113fecb3fd2afea9c33143512663e3.png";